import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css'
import './index.css';
import App from './App';
import 'overlayscrollbars/css/OverlayScrollbars.css'

import * as serviceWorker from './serviceWorker';

import { supportsWebp } from './utils'

supportsWebp(window).then(res => {
  if (res) {
    window.document.body.className = 'webp'
  }
}).catch(err => {
  console.log(err)
})

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
